import {
  BylineAuthor,
  BylineProps,
} from "design-system/components/primitives/byline/byline";
import { createContentfulProps } from "frontend/contentful/lib/create-contentful-props";
import { isContentType } from "frontend/contentful/lib/is-content-type";
import {
  ArticlePageEntry,
  PodcastEpisodePageEntry,
} from "frontend/contentful/schema/pages";
import { useContentful } from "frontend/hooks/use-contentful";
import { createBylineAuthorProps } from "../primitives/byline-author.props";

export const createBylineProps = createContentfulProps<
  ArticlePageEntry | PodcastEpisodePageEntry,
  BylineProps
>(({ entry, createEditAttributes }) => {
  const { getIsPersonPastHbsFaculty, getEntry } = useContentful();

  const props: BylineProps = {
    type: "ShowAll",
    editAttributes: {
      publicationDate: createEditAttributes({
        entry,
        fieldId: "publicationDate",
      }),
    },
  };

  props.authors = [];

  if (isContentType<ArticlePageEntry>("articlePage", entry)) {
    entry.fields.authors?.forEach((person) => {
      const bylinePersonProps = createBylineAuthorProps(person);
      if (bylinePersonProps) props.authors?.push(bylinePersonProps);
    });
    if (props.authors.length === 0 && entry.fields.legacyStoryBylineTypein) {
      const legacyAuthorByline: BylineAuthor = {
        name: entry.fields.legacyStoryBylineTypein,
      };
      props.authors.push(legacyAuthorByline);
    }
  }

  if (isContentType<PodcastEpisodePageEntry>("podcastEpisodePage", entry)) {
    const podcast = getEntry(entry.fields.podcastEpisode);
    props.publicationDate = podcast?.fields.publicationDate;
  } else {
    props.publicationDate = entry.fields.publicationDate;
  }

  props.featuredAuthors = [];
  const relatedFaculty = isContentType<PodcastEpisodePageEntry>(
    "podcastEpisodePage",
    entry,
  )
    ? getEntry(entry.fields.podcastEpisode)?.fields.relatedFaculty
    : entry.fields.relatedFaculty;
  relatedFaculty?.forEach((person) => {
    if (getIsPersonPastHbsFaculty(person)) return;
    const bylinePersonProps = createBylineAuthorProps(person);
    if (bylinePersonProps) props.featuredAuthors?.push(bylinePersonProps);
  });

  if (isContentType<ArticlePageEntry>("articlePage", entry)) {
    entry.fields.relatedAlum?.forEach((person) => {
      const bylinePersonProps = createBylineAuthorProps(person);
      if (bylinePersonProps) props.featuredAuthors?.push(bylinePersonProps);
    });
  }

  if (props.featuredAuthors?.length > 0) props.headshots = true;

  return props;
});
